module.exports = __webpack_public_path__ + "3b55589e9d69ca9cd17f92d71f6fb0ee.jpg";